// types.
export interface Props {
  startAt: string;
  updatedAt?: string;
  country: 'MX' | 'CO';
}

export const ZONE_BY_COUNTRY = {
  MX: 'America/Mexico_City',
  CO: 'America/Bogota',
};

export type Duration = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const pad = (n: number): string => String(n).padStart(2, '0');

const HOURS_TO_MS = (hours: number) => hours * 60 * 60 * 1000;

export const DURATION_THRESHOLDS = {
  warning: HOURS_TO_MS(1),
  danger: HOURS_TO_MS(2),
};

export const getColorFromDuration = (ms: number): string => {
  if (ms >= DURATION_THRESHOLDS.danger) return '#dc3545'; // red
  if (ms >= DURATION_THRESHOLDS.warning) return 'orange';
  return 'green';
};
